const state = {
    icons_list: [],
    loading: false,
};

export default state;